export default __webpack_public_path__ + "static/media/Loading.92101fde.gif";